module.exports = {
  APILOCALURL: 'https://localhost:7076/api/',
  APISERVERURL: 'https://brokersyncapi.azurewebsites.net/api/',
  APIPRODUCTIONURL:'https://brokersynapi-a0hxbbbeh8dvava2.canadacentral-01.azurewebsites.net/api/',
  APIACTIVATEURL: 'https://brokersynapi-a0hxbbbeh8dvava2.canadacentral-01.azurewebsites.net/api/',
  AWSACCESSKEY:'AKIAWAA656RB4WCTRE4X',
  AWSSECRETKEY:'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',
  LOGIN: 'home/login',
  REGISTER: 'home/register',
  REGISTERCARD: 'home/registercard',
  SENDRESETPASSWORD:'home/SendResetLink',
  RESETPASSWORD: 'home/resetpassword',
  CARDSETUP:'home/cardsetup',

  LANDINGPAGEGET:'Landing',
  LANDINGPAGECREATE:'Landing',
  LANDINGPAGEUPDATE:'Landing',
  
  GETCLIENTUSERS:'user/GetByClient',
  GETBROKERS:'user/GetBrokers',
  GETUSER:'user/GetById',
  GETADMIN:'user/GetAdmin',
  CHANGEPASSWORD:'user/ChangePassword',
  UPDATEPROFILE:'user/Profile',
  USERRESETPASSWORD:'user/ResetPassword',
  UPDATESTATUS:'user/Status',
  DELETEUSER:'user',
  CREATEUSER:'user/create',
  UPDATEBROKER:'user/updatebroker',

  GETALLCLIENTS:'client/GetAll',

  CREATECLIENT:'client/create',
  UPDATECLIENT:'client',
  GETCLIENT:'client/Get',
  GETCLIENTBYID:'client/GetById',
  SEARCHCLIENT:'client/search',
  DELETECLIENT:'client',
  BONUSCLIENTCREDITS:'client/bonus',
  CLIENTDETAILS:'client/details',
  GETCLIENTPHONENUMBERS:'client/GetPhoneNumbers',
  BUYCLIENTPHONENUMBER:'client/BuyPhoneNumber',
  CLIENTRECHARGE:'client/Recharge',
  CLIENTCALLING:'client/make-call',
  SENDAPPLICANTEMAIL: 'client/SendEmail',
  UPDATEADDONS: 'client/AddOns',


  GETCLIENTDOCUMENTS:'clientdocument/GetByLendingApplicationId',
  CREATECLIENTDOCUMENT:'clientdocument/create',
  DELETECLIENTDOCUMENT:'clientdocument',

  CREATEINDUSTRY:'Industry/create',
  UPDATEINDUSTRY:'Industry',
  GETINDUSTRY:'Industry/get',
  GETALLINDUSTRY:'Industry/getall',
  GETINDUSTRYBYID:'Industry',
  SEARCHINDUSTRY:'Industry/search',
  DELETEINDUSTRY:'Industry',

  CREATECLIENTEMAIL:'ClientEmail/create',
  UPDATECLIENTEMAIL:'ClientEmail',
  GETCLIENTEMAILS:'ClientEmail/getbyclient',
  DELETECLIENTEMAIL:'ClientEmail',

  CREATEUSERTEMPLATE:'UserTemplate/create',
  UPDATEUSERTEMPLATE:'UserTemplate',
  GETUSERTEMPLATES:'UserTemplate/getbyuser',
  DELETEUSERTEMPLATE:'UserTemplate',

  CREATELENDER:'lender/create',
  UPDATELENDER:'lender',
  GETLENDER:'lender/get',
  GETALLLENDERS:'lender/getall',
  GETLENDERBYID:'lender',
  SEARCHLENDER:'lender/search',
  DELETELENDER:'lender',

  CREATESTATE:'state/create',
  UPDATESTATE:'state',
  GETSTATE:'state/get',
  GETAllSTATE:'state/getall',
  GETSTATEBYID:'state',
  SEARCHSTATE:'state/search',
  DELETESTATE:'state',

  CREATELEAD:'lead/create',
  UPDATELEAD:'lead',
  GETLEAD:'lead/get',
  GETAllLEAD:'lead/getall',
  GETLEADBYID:'lead',
  SEARCHLEAD:'lead/search',
  DELETELEAD:'lead',

  CREATELENDINGAPPLICATION:'lendingApplication/create',
  UPLOADLENDINGAPPLICATION:'lendingApplication/Upload',
  UPDATELENDINGAPPLICATION:'lendingApplication',
  GETLENDINGAPPLICATIONS:'lendingApplication/get',
  GETALLLENDINGAPPLICATIONS:'lendingApplication/getall',
  GETLENDINGAPPLICATION:'lendingApplication',
  GETUSERLENDINGAPPLICATION:'lendingApplication/user',
  GETCLIENTLENDINGAPPLICATION:'lendingApplication/client',
  SEARCHLENDINGAPPLICATION:'lendingApplication/search',
  ADMINSEARCHLENDINGAPPLICATION:'lendingApplication/admin-search',
  DELETELENDINGAPPLICATION:'lendingApplication',
  GENERATECALLTOKEN:'lendingApplication/GenerateCallToken',
  SENDSMSTOAPPLICANT:'lendingApplication/Sendsms',

  CREATEAPPLICATIONLENDER:'ApplicationLender/create',
  UPDATEAPPLICATIONLENDER:'ApplicationLender',
  GETAPPLICATIONLENDER:'ApplicationLender',
  GETAPPLICATIONLENDERBYAPPLICATION:'ApplicationLender/GetByLendingApplication',
  GETAPPLICATIONLENDERBYLENDER:'ApplicationLender/GetByLender',
  APPLICATIONLENDERMULTI:'ApplicationLender/Multi',
  DELETEAPPLICATIONLENDER:'ApplicationLender',
  GETSCORECARD:'ApplicationLender/GetScoreCard',
  GETAPPLICATIONLENDERBYSTATUS:'ApplicationLender/GetByStatus',

  CREATEAPPLICATIONLOAN:'ApplicationLoan/create',
  UPDATEAPPLICATIONLOAN:'ApplicationLoan',
  GETAPPLICATIONLOAN:'ApplicationLoan',
  GETAPPLICATIONLOANBYAPPLICATION:'ApplicationLoan/GetByLendingApplication',
  DELETEAPPLICATIONLOAN:'ApplicationLoan',
  GETLENDERSCOMMISSIONS:'ApplicationLoan/GetCommission',
  GETAPPLICATIONLOANBYSTATUS:'ApplicationLoan/GetByStatus',

  USERDASHBOARD:'Dashboard/UserCount',
  CLIENTDASHBOARD:'Dashboard/ClientCount',
  ADMINDASHBOARD:'Dashboard/AdminCount',
  GETLENDINGAPPLICATIONREPORT:'Dashboard/LendingApplications',

  CREATECREDITPRICING:'creditpricing/create',
  UPDATECREDITPRICING:'creditpricing',
  GETCREDITPRICING:'creditpricing/get',
  DELETECREDITPRICING:'creditpricing',

  CREATEPRICING:'pricing/create',
  UPDATEPRICING:'pricing',
  GETPRICING:'pricing/get',
  DELETEPRICING:'pricing',

  GETCREDITTRANSACTIONS:'credittransaction/get',
  GETUSERCREDITTRANSACTIONS:'credittransaction/client',
  CREATECREDITTRANSACTION:'credittransaction/create',
  UPDATECREDITTRANSACTION:'credittransaction',  
  DELETECREDITTRANSACTION:'credittransaction',

  CREATECREDITUSAGEPRICE:'creditusageprice/create',
  UPDATECREDITUSAGEPRICE:'creditusageprice',
  GETCREDITUSAGEPRICES:'creditusageprice/get',
  DELETECREDITUSAGEPRICE:'creditusageprice',

  GETUSERSUBSCRIPTIONS:'clientsubscription/get',
  GETUSERSUBSCRIPTIONBYUSER:'clientsubscription/user',
  CREATECLIENTSUBSCRIPTION:'clientsubscription/create',
  UPDATEUSERSUBSCRIPTION:'clientsubscription',  
  DELETEUSERSUBSCRIPTION:'clientsubscription',

  GETSUBSCRIPTIONS:'subscription/get',
  CREATESUBSCRIPTION:'subscription/create',
  UPDATESUBSCRIPTION:'subscription',  
  DELETESUBSCRIPTION:'subscription',

  GETPAYMENTTRANSACTIONS:'PaymentTransaction/Get',
  GETUSERPAYMENTTRANSACTIONS:'PaymentTransaction/Client',
  CREATEPAYMENTTRANSACTION:'PaymentTransaction/Create',
  DELETEPAYMENTTRANSACTION:'PaymentTransaction',

  GETCLIENTLENDERS:'ClientLender/Client',
  CREATECLIENTLENDER:'ClientLender/Create',
  DELETECLIENTLENDER:'ClientLender',

  REPORTCLIENTS:'Report/GetClients',
  REPORTPAYMENTS:'Report/GetPayments',
  REPORTSUBSCRIPTIONS:'Report/GetSubscriptions',
  REPORTAPPROVELOANS:'Report/GetApprovedLoans',
  STATUSREPORT: "Report/GetApplicationStatusReport",

  GETCLIENTRENEWALS:'ClientRenewal/Get',
  UPDATECLIENTRENEWAL:'ClientRenewal/UpdateStatus',
  CANCELCLIENTRENEWAL:'ClientRenewal/Cancel',
  CHANGESUBSCRIPTION:'ClientRenewal/Change',
  GETCLIENTPLANS:'ClientRenewal/GetSubscriptions',

  GETHERO: "HeroSection",
  CREATEHERO: "HeroSection",
  UPDATEHERO: "HeroSection",
  DELETEHERO: "HeroSection",

  GETABOUT: "AboutSection",
  UPDATEABOUT: "AboutSection",

  GETCARDS: "CardSection",
  CREATECARD: "CardSection",
  UPDATECARD: "CardSection",
  DELETECARD: "CardSection",

  GETSERVICES: "ServiceSection",
  UPDATESERVICE: "ServiceSection",

  GETFOOTER: "FooterSection",
  UPDATEFOOTER: "FooterSection",

}